module.exports = __webpack_public_path__ + "img/NL547.356b2823.png";